var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#007bff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8,8 L8,4 C8,2.8954305 8.8954305,2 10,2 L14,2 C15.1045695,2 16,2.8954305 16,4 L16,8 L20,8 C21.1045695,8 22,8.8954305 22,10 L22,14 C22,15.1045695 21.1045695,16 20,16 L16,16 L16,20 C16,21.1045695 15.1045695,22 14,22 L10,22 C8.8954305,22 8,21.1045695 8,20 L8,16 L4,16 C2.8954305,16 2,15.1045695 2,14 L2,10 C2,8.8954305 2.8954305,8 4,8 L8,8 Z M10,4 L10,9 C10,9.55228475 9.55228475,10 9,10 L4,10 L4,14 L9,14 C9.55228475,14 10,14.4477153 10,15 L10,20 L14,20 L14,15 C14,14.4477153 14.4477153,14 15,14 L20,14 L20,10 L15,10 C14.4477153,10 14,9.55228475 14,9 L14,4 L10,4 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthSvgrepoCom);
export default __webpack_public_path__ + "static/media/health-svgrepo-com.bd821832fe88266e636374c7b4dde68c.svg";
export { ForwardRef as ReactComponent };